(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('AlarmController', AlarmController);

    AlarmController.$inject = ['$scope', '$state', '$stateParams', 'AlarmService'];

    function AlarmController($scope, $state, $stateParams, AlarmService) {
        var vm = this;
        vm.historyHeader = false;
        vm.tableTitle = 'list';

        vm.openSettings = openSettings;
        vm.configScrollbar = {
            theme: 'dark',
            scrollbarPosition: 'inside',
            scrollButtons: {
                enable: false
            }
        };

        function openSettings() {
            AlarmService.settingsModalConstructor();
        }
    }
})();